import { useTranslation } from 'react-i18next'
import { showDateTime } from 'helpers/date/showDate'

import { CheckIcon } from '@pleio/icons/check'

import Flexer from 'js/components/Flexer/Flexer'
import IconButton from 'js/components/IconButton'

import styles from './ListItem.module.css'

type ListItemProps = {
    entity: any
    isCheckedIn: boolean
    onToggleCheckIn: (email: string) => Promise<void>
}

const ListItem = ({ entity, isCheckedIn, onToggleCheckIn }: ListItemProps) => {
    const { t } = useTranslation()

    const { name, email, timeCheckedIn } = entity

    const toggleCheckIn = () => {
        return onToggleCheckIn(email)
    }

    return (
        <tr className={styles.wrapper}>
            <td>
                <Flexer justifyContent="flex-start">
                    <IconButton
                        size="large"
                        variant={isCheckedIn ? 'primary' : 'secondary'}
                        className="ToggleCheckInButton"
                        tooltip={
                            isCheckedIn
                                ? t('entity-event.remove-check-in')
                                : t('entity-event.check-in')
                        }
                        onHandle={toggleCheckIn}
                    >
                        <CheckIcon />
                    </IconButton>
                    <span>{name}</span>
                </Flexer>
            </td>
            <td>{email}</td>
            {isCheckedIn && (
                <td style={{ textAlign: 'right' }}>
                    {showDateTime(timeCheckedIn, true, true)}
                </td>
            )}
        </tr>
    )
}

export default ListItem
